import React from "react";
import { Link, useLocation } from "react-router-dom";
import { isCustomerPage } from "../lib/customerPages";
import { FaFire, FaInstagram } from "react-icons/fa";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL } from "../constants/links";
import "./Footer.css";
import { t } from "../i18n";

const Footer: React.FC = () => {
  // Fans on a talent's page (QR / link / fan mode) are here to request a
  // song — the desktop companion is a talent tool (founder, 1.4.1).
  const fanSide = isCustomerPage(useLocation().pathname);
  return (
    <div className="footer-block">
      <footer className="footer" role="contentinfo">
        <p className="copy">{t("footer.requestaAllRightsReserved")}</p>
        {/* Two rows (founder, 2026-10-26): Instagram and Top Songs, each
            with its icon; then the plain links. */}
        <nav className="footer-nav" aria-label={t("footer.footer")}>
          <div className="footer-row">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link footer-link--instagram"
              aria-label={t("footer.followRequestAppOn", { INSTAGRAM_HANDLE })}
            >
              <FaInstagram aria-hidden />
              {t("footer.followUsOnInstagram")}
            </a>
            <Link
              to="/fan/leaderboard"
              className="footer-link footer-link--top-songs"
            >
              <FaFire aria-hidden />
              {t("dJLeaderboard.topSongs")}
            </Link>
          </div>
          <div className="footer-row">
            {!fanSide && (
              <Link to="/download" className="footer-link">
                {t("footer.downloadForMac")}
              </Link>
            )}
            <Link to="/about" className="footer-link">
              {t("footer.aboutUs")}
            </Link>
            <Link to="/privacy" className="footer-link">
              {t("footer.privacyPolicy")}
            </Link>
            <Link to="/terms" className="footer-link">
              {t("footer.termsConditions")}
            </Link>
          </div>
        </nav>
      </footer>
    </div>
  );
};

export default Footer;
